import React from 'react';
import { Login } from '../../pages/Login';
import { Home } from '../../pages/Home';
import { Registration } from '../../pages/Registration';
import { TopUpBalance } from '../../pages/TopUpBalance';
import { Success, SuccessPublicPages, SuccessAddAccount } from '../../pages/Success';
import { TimeOutPage } from '../../pages/TimeOut';
import { AccountSetting } from '../../pages/AccountSetting';
import { UserSurvey } from '../../pages/UserSurvey';
import { GlobalRouteNames } from '../../models/Common';
import { ConnectionBrizTv } from '../../pages/ConnectionBrizTv';
import { ServiceManagement } from '../../pages/ServiceManagement';
import { PaymentHistory } from '../../pages/PaymentHistory';
import { ChangeService } from '../../pages/ChangeService';
import { OffersForYou } from '../../pages/OffersForYou';
import ForgotPasswordPage from '../../pages/ForgotPasswordPage/ForgotPasswordPage';
import PasswordRecoveryAssistancePage from '../../pages/PasswordRecoveryAssistancePage/PasswordRecoveryAssistancePage';
import PasswordRecoveryByPhonePage from '../../pages/PasswordRecoveryByPhonePage/PasswordRecoveryByPhonePage';
import { PaymentRefactor } from '../../pages/Payment/PaymentRefactor';
import { DailyPayment } from '../../pages/Payment';

export interface IRoute {
  path?: string;
  component: React.ComponentType;
  exact?: boolean;
  requiredPermissions?: string[];
}

export const publicRoutes: IRoute[] = [
  { path: GlobalRouteNames.LoginPage, component: Login, exact: false },
  { path: GlobalRouteNames.SuccessPublicPage, component: SuccessPublicPages, exact: false },
  { path: GlobalRouteNames.SuccessAddAccount, component: SuccessAddAccount, exact: false },
  { path: GlobalRouteNames.TimeOutError, component: TimeOutPage, exact: false },
  { path: GlobalRouteNames.SurveyPage, component: UserSurvey, exact: false },
];

export const privateRoutes: IRoute[] = [
  { path: GlobalRouteNames.HomePage, component: Home, exact: true },
  { path: GlobalRouteNames.RegistrationPage, component: Registration, exact: false },
  {
    path: GlobalRouteNames.TopUpBalancePage,
    component: TopUpBalance,
    exact: false,
    requiredPermissions: ['Payments.AddMoney'],
  },
  { path: GlobalRouteNames.SuccessPage, component: Success, exact: false },
  { path: GlobalRouteNames.AccountSettingPage, component: AccountSetting, exact: false },
  {
    path: GlobalRouteNames.ServicePayment,
    component: PaymentRefactor,
    exact: false,
    requiredPermissions: ['Services.Activate'],
  },
  {
    path: GlobalRouteNames.ServiceSuspension,
    component: PaymentRefactor,
    exact: false,
    requiredPermissions: ['Services.Suspend'],
  },
  {
    path: GlobalRouteNames.DailyServicePayment,
    component: DailyPayment,
    exact: false,
    requiredPermissions: ['Services.Activate'],
  },
  {
    path: GlobalRouteNames.ConnectionBrizTv,
    component: ConnectionBrizTv,
    exact: false,
    requiredPermissions: ['Services.Iptv.BrizTVAvailable'],
  },
  { path: GlobalRouteNames.ServiceManagement, component: ServiceManagement, exact: false },
  { path: GlobalRouteNames.PaymentHistory, component: PaymentHistory, exact: false },
  { path: GlobalRouteNames.OffersForYou, component: OffersForYou, exact: false },
  {
    path: GlobalRouteNames.ChangeService,
    component: ChangeService,
    exact: false,
  },
  {
    component: ForgotPasswordPage,
    path: GlobalRouteNames.ResetPasswordForm,
    exact: true,
  },
  {
    component: PasswordRecoveryAssistancePage,
    path: GlobalRouteNames.PasswordRecoveryAssistance,
    exact: true,
  },
  {
    component: PasswordRecoveryByPhonePage,
    path: GlobalRouteNames.PasswordRecoveryByPhone,
    exact: true,
  },
];
